import { isDefined } from "@clipboard-health/util-ts";
import { Chip } from "@mui/material";

import {
  type PlacementApplicationStatus,
  placementApplicationStatusMap,
} from "../types/fetchPlacementApplications.schema";

export interface PlacementApplicationStatusChipProps {
  status: PlacementApplicationStatus;
  size?: "small" | "medium";
  variant?: "outlined" | "filled";
}

export function PlacementApplicationStatusChip(props: PlacementApplicationStatusChipProps) {
  const { status, size = "small", variant = "outlined" } = props;
  const statusInfo = placementApplicationStatusMap[status];

  if (!isDefined(statusInfo)) {
    return null;
  }

  return (
    <Chip
      size={size}
      variant={variant}
      label={statusInfo.label}
      color={statusInfo.color}
      sx={(theme) => ({
        borderRadius: theme.shape.borderRadius / 2,
        height: theme.spacing(3),
        px: theme.spacing(1),
        width: "max-content",
        fontWeight: 400,
      })}
    />
  );
}
